import {
  useEffect,
  useState,
  useMemo,
  useCallback,
  useRef,
} from "react";
import { Col, Row } from "reactstrap";
import { useMediaQuery } from "react-responsive";
import { Link } from "react-router-dom";
import { APISD } from "../../../../../../../config/apisd";
import { APIMS } from "../../../../../../../config/apims";
import "bulma/css/bulma.css";
import "../../../../../../../index.css";
import { FaArrowAltCircleRight } from "react-icons/fa";
import Swal from "sweetalert2";
import ModalAdd from "./modal/add";
import ModalUpdate from "./modal/update";
import ToastError from "../../../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../../../NotificationToast/ToastSuccess";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPenToSquare,
  faTrash,
  faPlus,
  faList,
} from "@fortawesome/free-solid-svg-icons";
import { PulseLoader } from "react-spinners";

const filterCss = `
  @keyframes shimmer {
    0% {
      background-position: -468px 0;
    }

    100% {
      background-position: 468px 0;
    }
  }

  .shimmer {
    animation: shimmer 1.2s linear infinite;
    background: linear-gradient(
      to right,
      #ddeaff 8%,
      #f4f8ff 18%,
      #ddeaff 33%
    );
    background-size: 800px 104px;
  }

  .shimmer-select {
    height: 35px;
    border-radius: 12px;
  }

  .kk-filter-select {
    border: 1px solid #d9defa;
    border-radius: 12px;
    font-size: 14px;
    padding: 10px 12px;
    background: #ffffff;
    min-width: 170px;
    outline: none;
  }

  .kk-filter-select:disabled {
    background: #f5f5f5;
    cursor: not-allowed;
    color: #8b8b8b;
  }

  .kk-filter-button {
    border: none;
    font-size: 13px;
    padding: 10px 16px;
    border-radius: 12px;
    color: #ffffff;
    transition: 0.2s ease;
  }

  .kk-filter-button:not(:disabled):hover {
    opacity: 0.9;
  }

  .kk-mobile-filter {
    width: 100%;
    margin-right: 0 !important;
  }

  @media (max-width: 780px) {
    .kk-filter-select {
      width: 100%;
      min-width: 0;
    }
  }
`;

export default function KegiatanKokurikuler() {
  document.title = "Kegiatan Kokurikuler";

  const token = localStorage.getItem("token");
  const storageLevel = localStorage.getItem("level") || "";
  // const storageBranchGrouping =
  //   localStorage.getItem("ysb_branch_id") || "";

  const ascending = 1;
  const page = 1;
  const limit = 1000;

  const isTabletOrMobile = useMediaQuery({
    query: "(max-width: 780px)",
  });

  /*
  |--------------------------------------------------------------------------
  | DATA TABLE
  |--------------------------------------------------------------------------
  */

  const [getData, setGetData] = useState([]);
  const [isFetching, setIsFetching] = useState(false);

  /*
  |--------------------------------------------------------------------------
  | SEARCH DAN PAGINATION
  |--------------------------------------------------------------------------
  */

  const [searchKeyword, setSearchKeyword] = useState("");
  const [tablePage, setTablePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  /*
  |--------------------------------------------------------------------------
  | MODAL
  |--------------------------------------------------------------------------
  */

  const [id, setId] = useState();
  const [dataUpdate, setDataUpdate] = useState();
  const [modalAdd, setModalAdd] = useState(false);
  const [modalUpdate, setModalUpdate] = useState(false);

  /*
  |--------------------------------------------------------------------------
  | FILTER STATE
  |--------------------------------------------------------------------------
  */

  const [loading, setLoading] = useState(true);
  const [loadingSchool, setLoadingSchool] = useState(false);
  const [loadingLevel, setLoadingLevel] = useState(false);
  const [loadingKelas, setLoadingKelas] = useState(false);

  const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);
  const [getDataBranch, setGetDataBranch] = useState([]);
  const [getDataSchool, setGetDataSchool] = useState([]);
  const [getDataLevel, setGetDataLevel] = useState([]);
  const [getDataKelas, setGetDataKelas] = useState([]);

  const [namaTA, setNamaTA] = useState("");
  const [namaSmstr, setNamaSmstr] = useState("");

  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isFilterDirty, setIsFilterDirty] = useState(false);

  const [form2, setForm2] = useState({
    ysb_semester_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
    ysb_grade_level_id: "",
    ysb_kelas_id: "",
  });

  /*
  |--------------------------------------------------------------------------
  | REF UNTUK AUTO LOAD
  |--------------------------------------------------------------------------
  */

  const firstLoadDone = useRef(false);
  const initSchoolDone = useRef(false);
  const initLevelDone = useRef(false);
  const initKelasDone = useRef(false);

  /*
  |--------------------------------------------------------------------------
  | HEADERS
  |--------------------------------------------------------------------------
  */

  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  /*
  |--------------------------------------------------------------------------
  | HELPER
  |--------------------------------------------------------------------------
  */

  const sameValue = useCallback((valueA, valueB) => {
    return String(valueA ?? "") === String(valueB ?? "");
  }, []);

  const sortSchools = useCallback((schools = []) => {
    const order = ["SD", "SMP", "SMA"];

    return [...schools].sort((a, b) => {
      const nameA = (a?.school_name || "").toUpperCase();
      const nameB = (b?.school_name || "").toUpperCase();

      const indexA = order.findIndex((item) =>
        nameA.includes(item)
      );

      const indexB = order.findIndex((item) =>
        nameB.includes(item)
      );

      const safeIndexA =
        indexA === -1 ? order.length : indexA;

      const safeIndexB =
        indexB === -1 ? order.length : indexB;

      if (safeIndexA !== safeIndexB) {
        return safeIndexA - safeIndexB;
      }

      return nameA.localeCompare(nameB, "id", {
        numeric: true,
        sensitivity: "base",
      });
    });
  }, []);

  const sortLevels = useCallback((levels = []) => {
    return [...levels].sort((a, b) =>
      (a?.name_level || "").localeCompare(
        b?.name_level || "",
        "id",
        {
          numeric: true,
          sensitivity: "base",
        }
      )
    );
  }, []);

  const sortKelas = useCallback((kelas = []) => {
    return [...kelas].sort((a, b) =>
      (a?.name_kelas || "").localeCompare(
        b?.name_kelas || "",
        "id",
        {
          numeric: true,
          sensitivity: "base",
        }
      )
    );
  }, []);

  const removeBasementBekasi = useCallback(
    (schools = [], branchId) => {
      if (branchId === "BKS") {
        return schools.filter(
          (school) =>
            school?.school_code !== "BASEMENT_BEKASI"
        );
      }

      return schools;
    },
    []
  );

  /*
  |--------------------------------------------------------------------------
  | FETCH CABANG DAN SEMESTER
  |--------------------------------------------------------------------------
  */

  const fetchInitialFilter = useCallback(async () => {
    setLoading(true);

    try {
      const [branchResponse, semesterResponse] =
        await Promise.all([
          APIMS.get(
            `/api/access/branches?page=1&limit=1000&ascending=${ascending}&search=`,
            fetchParams
          ),
          APIMS.get(
            `/api/access/semesters?page=1&limit=1000&ascending=${ascending}&search=`,
            fetchParams
          ),
        ]);

      if (branchResponse?.status === 200) {
        const branches =
          branchResponse?.data?.data || [];

        setGetDataBranch(branches);

        // const savedBranch = branches.find((branch) =>
        //   sameValue(
        //     branch?.branch_code,
        //     storageBranchGrouping
        //   )
        // );

        // const defaultBranch =
        //   savedBranch?.branch_code ||
        //   branches[0]?.branch_code ||
        //   "";

        // setForm2((prev) => ({
        //   ...prev,
        //   ysb_branch_id: defaultBranch,
        // }));
        if (branches.length > 0) {
  const firstBranch = branches[0]?.branch_code || "";

  setForm2((prev) => ({
    ...prev,
    ysb_branch_id: firstBranch,
  }));
} else {
  setForm2((prev) => ({
    ...prev,
    ysb_branch_id: "",
  }));
}
      }

      if (semesterResponse?.status === 200) {
        const semesters =
          semesterResponse?.data?.data || [];

        const activeSemester =
          semesters.find(
            (semester) =>
              Number(semester?.status) === 1
          ) || semesters[0];

        setGetDataSemesterMap(semesters);

        if (activeSemester) {
          setNamaTA(activeSemester?.name_year || "");
          setNamaSmstr(
            activeSemester?.semester || ""
          );

          setForm2((prev) => ({
            ...prev,
            ysb_semester_id:
              activeSemester?.id || "",
          }));
        }
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title:
          error?.response?.data?.message ||
          "Gagal memuat data awal filter",
      });
    } finally {
      setLoading(false);
    }
  }, [
    ascending,
    fetchParams,
    sameValue,
  ]);

  useEffect(() => {
    fetchInitialFilter();
  }, [fetchInitialFilter]);

  /*
  |--------------------------------------------------------------------------
  | FETCH SEKOLAH BERDASARKAN CABANG
  |--------------------------------------------------------------------------
  */

  const fetchSchoolsByBranch = useCallback(
    async (branchId) => {
      initSchoolDone.current = false;
      initLevelDone.current = false;
      initKelasDone.current = false;

      setLoadingSchool(true);

      setGetDataSchool([]);
      setGetDataLevel([]);
      setGetDataKelas([]);

      try {
        const response = await APIMS.get(
          `/api/access/schools?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );

        if (response?.status === 200) {
          let schools =
            response?.data?.data || [];

          if (
            storageLevel === "developer" ||
            storageLevel === "superadmin"
          ) {
            schools = schools.filter((school) =>
              sameValue(
                school?.ysb_branch_id,
                branchId
              )
            );
          }

          schools = removeBasementBekasi(
            schools,
            branchId
          );

          schools = sortSchools(schools);

          setGetDataSchool(schools);

          const firstSchool =
            schools[0]?.school_code || "";

          setForm2((prev) => ({
            ...prev,
            ysb_school_id: firstSchool,
            ysb_grade_level_id: "",
            ysb_kelas_id: "",
          }));

          if (!firstSchool) {
            initLevelDone.current = true;
            initKelasDone.current = true;
          }
        }
      } catch (error) {
        setGetDataSchool([]);
        setGetDataLevel([]);
        setGetDataKelas([]);

        setForm2((prev) => ({
          ...prev,
          ysb_school_id: "",
          ysb_grade_level_id: "",
          ysb_kelas_id: "",
        }));

        ToastError.fire({
          icon: "error",
          title:
            error?.response?.data?.message ||
            "Gagal memuat data sekolah",
        });
      } finally {
        initSchoolDone.current = true;
        setLoadingSchool(false);
      }
    },
    [
      ascending,
      fetchParams,
      removeBasementBekasi,
      sameValue,
      sortSchools,
      storageLevel,
    ]
  );

  useEffect(() => {
    if (!form2.ysb_branch_id) {
      setGetDataSchool([]);
      setGetDataLevel([]);
      setGetDataKelas([]);

      setForm2((prev) => ({
        ...prev,
        ysb_school_id: "",
        ysb_grade_level_id: "",
        ysb_kelas_id: "",
      }));

      return;
    }

    fetchSchoolsByBranch(
      form2.ysb_branch_id
    );
  }, [
    form2.ysb_branch_id,
    fetchSchoolsByBranch,
  ]);

  /*
  |--------------------------------------------------------------------------
  | FETCH TINGKATAN BERDASARKAN SEKOLAH
  |--------------------------------------------------------------------------
  */

  const fetchLevelsBySchool = useCallback(
    async (schoolId, branchId) => {
      initLevelDone.current = false;
      initKelasDone.current = false;

      setLoadingLevel(true);

      setGetDataLevel([]);
      setGetDataKelas([]);

      try {
        const response = await APIMS.get(
          `/api/grade-levels?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );

        if (response?.status === 200) {
          let levels =
            response?.data?.data || [];

          levels = levels.filter((level) =>
            sameValue(
              level?.ysb_school_id,
              schoolId
            )
          );

          if (branchId) {
            levels = levels.filter((level) =>
              sameValue(
                level?.ysb_branch_id,
                branchId
              )
            );
          }

          levels = sortLevels(levels);

          setGetDataLevel(levels);

          const firstLevel =
            levels[0]?.id || "";

          setForm2((prev) => ({
            ...prev,
            ysb_grade_level_id: firstLevel,
            ysb_kelas_id: "",
          }));

          if (!firstLevel) {
            initKelasDone.current = true;
          }
        }
      } catch (error) {
        initKelasDone.current = true;

        setGetDataLevel([]);
        setGetDataKelas([]);

        setForm2((prev) => ({
          ...prev,
          ysb_grade_level_id: "",
          ysb_kelas_id: "",
        }));

        ToastError.fire({
          icon: "error",
          title:
            error?.response?.data?.message ||
            "Gagal memuat data tingkatan",
        });
      } finally {
        initLevelDone.current = true;
        setLoadingLevel(false);
      }
    },
    [
      ascending,
      fetchParams,
      sameValue,
      sortLevels,
      storageLevel,
    ]
  );

  useEffect(() => {
    if (!form2.ysb_school_id) {
      setGetDataLevel([]);
      setGetDataKelas([]);

      setForm2((prev) => ({
        ...prev,
        ysb_grade_level_id: "",
        ysb_kelas_id: "",
      }));

      return;
    }

    fetchLevelsBySchool(
      form2.ysb_school_id,
      form2.ysb_branch_id
    );
  }, [
    form2.ysb_school_id,
    form2.ysb_branch_id,
    fetchLevelsBySchool,
  ]);

  /*
  |--------------------------------------------------------------------------
  | FETCH KELAS BERDASARKAN TINGKATAN
  |--------------------------------------------------------------------------
  */

  const fetchKelasByLevel = useCallback(
    async (
      gradeLevelId,
      schoolId,
      branchId
    ) => {
      initKelasDone.current = false;

      setLoadingKelas(true);
      setGetDataKelas([]);

      try {
        const response = await APIMS.get(
          `/api/kelas?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );

        if (response?.status === 200) {
          let kelas =
            response?.data?.data || [];

          kelas = kelas.filter((item) =>
            sameValue(
              item?.ysb_grade_level_id,
              gradeLevelId
            )
          );

          if (schoolId) {
            kelas = kelas.filter((item) =>
              sameValue(
                item?.ysb_school_id,
                schoolId
              )
            );
          }

          if (branchId) {
            kelas = kelas.filter((item) =>
              sameValue(
                item?.ysb_branch_id,
                branchId
              )
            );
          }

          kelas = sortKelas(kelas);

          setGetDataKelas(kelas);

          setForm2((prev) => ({
            ...prev,
            ysb_kelas_id:
              kelas[0]?.id || "",
          }));
        }
      } catch (error) {
        setGetDataKelas([]);

        setForm2((prev) => ({
          ...prev,
          ysb_kelas_id: "",
        }));

        ToastError.fire({
          icon: "error",
          title:
            error?.response?.data?.message ||
            "Gagal memuat data kelas",
        });
      } finally {
        initKelasDone.current = true;
        setLoadingKelas(false);
      }
    },
    [
      ascending,
      fetchParams,
      sameValue,
      sortKelas,
      storageLevel,
    ]
  );

  useEffect(() => {
    if (!form2.ysb_grade_level_id) {
      setGetDataKelas([]);

      setForm2((prev) => ({
        ...prev,
        ysb_kelas_id: "",
      }));

      return;
    }

    fetchKelasByLevel(
      form2.ysb_grade_level_id,
      form2.ysb_school_id,
      form2.ysb_branch_id
    );
  }, [
    form2.ysb_grade_level_id,
    form2.ysb_school_id,
    form2.ysb_branch_id,
    fetchKelasByLevel,
  ]);

  /*
  |--------------------------------------------------------------------------
  | STATUS FILTER
  |--------------------------------------------------------------------------
  */

  const isFilterReady =
    !!form2.ysb_semester_id &&
    !!form2.ysb_branch_id &&
    !!form2.ysb_school_id &&
    initSchoolDone.current &&
    initLevelDone.current &&
    initKelasDone.current &&
    !loadingSchool &&
    !loadingLevel &&
    !loadingKelas &&
    (
      getDataLevel.length === 0 ||
      !!form2.ysb_grade_level_id
    ) &&
    (
      getDataKelas.length === 0 ||
      !!form2.ysb_kelas_id
    );

  const isFilterComplete =
    isFilterDirty && isFilterReady;

  /*
  |--------------------------------------------------------------------------
  | HELPER FILTER DATA RESPONSE
  |--------------------------------------------------------------------------
  */

  const getValuesFromRow = useCallback(
    (row, paths = []) => {
      return paths
        .map((path) => {
          return path
            .split(".")
            .reduce((value, key) => {
              if (
                value === null ||
                value === undefined
              ) {
                return undefined;
              }

              return value[key];
            }, row);
        })
        .filter(
          (value) =>
            value !== null &&
            value !== undefined &&
            value !== ""
        );
    },
    []
  );

  const rowMatchesFilter = useCallback(
    (row, filter) => {
      const matches = (
        selectedValue,
        paths
      ) => {
        if (!selectedValue) {
          return true;
        }

        const values = getValuesFromRow(
          row,
          paths
        );

        /*
         * Jika endpoint sudah melakukan filter, tetapi
         * field relasinya tidak dikembalikan dalam response,
         * data tetap digunakan.
         */
        if (values.length === 0) {
          return true;
        }

        return values.some((value) =>
          sameValue(value, selectedValue)
        );
      };

      return (
        matches(
          filter.ysb_semester_id,
          [
            "ysb_semester_id",
            "semester_id",
            "semester.id",
          ]
        ) &&
        matches(
          filter.ysb_branch_id,
          [
            "ysb_branch_id",
            "branch_id",
            "branch.branch_code",
            "branch.code",
            "branch.id",
          ]
        ) &&
        matches(
          filter.ysb_school_id,
          [
            "ysb_school_id",
            "school_id",
            "school.school_code",
            "school.code",
            "school.id",
          ]
        ) &&
        matches(
          filter.ysb_grade_level_id,
          [
            "ysb_grade_level_id",
            "grade_level_id",
            "grade_level.id",
            "gradeLevel.id",
          ]
        ) &&
        matches(
          filter.ysb_kelas_id,
          [
            "ysb_kelas_id",
            "kelas_id",
            "kelas.id",
            "class_id",
            "class.id",
          ]
        )
      );
    },
    [getValuesFromRow, sameValue]
  );

  /*
  |--------------------------------------------------------------------------
  | GET DATA KEGIATAN
  |--------------------------------------------------------------------------
  */

  const GetResponseData =
    useCallback(async () => {
      if (
        !form2.ysb_semester_id ||
        !form2.ysb_branch_id ||
        !form2.ysb_school_id
      ) {
        return;
      }

      setSearchKeyword("");
      setIsFetching(true);

      const query = new URLSearchParams({
        page: "1",
        limit: "1000",
        ascending: String(ascending),
        search: "",
        ysb_semester_id: String(
          form2.ysb_semester_id
        ),
        ysb_branch_id: String(
          form2.ysb_branch_id
        ),
        ysb_school_id: String(
          form2.ysb_school_id
        ),
        semester: String(
          form2.ysb_semester_id
        ),
        branch: String(
          form2.ysb_branch_id
        ),
        school: String(
          form2.ysb_school_id
        ),
      });

      if (form2.ysb_grade_level_id) {
        query.append(
          "ysb_grade_level_id",
          String(
            form2.ysb_grade_level_id
          )
        );

        query.append(
          "grade_level",
          String(
            form2.ysb_grade_level_id
          )
        );

        query.append(
          "grade",
          String(
            form2.ysb_grade_level_id
          )
        );
      }

      if (form2.ysb_kelas_id) {
        query.append(
          "ysb_kelas_id",
          String(form2.ysb_kelas_id)
        );

        query.append(
          "kelas",
          String(form2.ysb_kelas_id)
        );

        query.append(
          "class",
          String(form2.ysb_kelas_id)
        );
      }

      try {
        const response = await APISD.get(
          `/api/fases?${query.toString()}`,
          fetchParams
        );

        if (response?.status === 200) {
          const rows =
            response?.data?.data || [];

          const filteredRows = rows.filter(
            (row) =>
              rowMatchesFilter(row, form2)
          );

          setGetData(filteredRows);
          setTablePage(1);
        }
      } catch (error) {
        setGetData([]);

        ToastError.fire({
          icon: "error",
          title:
            error?.response?.data?.message ||
            "Gagal memuat data",
        });
      } finally {
        setIsFetching(false);
      }
    }, [
      ascending,
      fetchParams,
      form2,
      rowMatchesFilter,
    ]);

  /*
  |--------------------------------------------------------------------------
  | AUTO LOAD PERTAMA
  |--------------------------------------------------------------------------
  */

  useEffect(() => {
    if (
      firstLoadDone.current ||
      !isFilterReady
    ) {
      return;
    }

    firstLoadDone.current = true;

    const loadInitialData = async () => {
      await GetResponseData();

      setIsFirstLoad(false);
      setIsFilterDirty(false);
    };

    loadInitialData();
  }, [
    GetResponseData,
    isFilterReady,
  ]);

  /*
  |--------------------------------------------------------------------------
  | HANDLE CHANGE FILTER
  |--------------------------------------------------------------------------
  */

  const handleChange = (event) => {
    const { name, value } = event.target;

    setForm2((prev) => {
      if (name === "ysb_branch_id") {
        return {
          ...prev,
          ysb_branch_id: value,
          ysb_school_id: "",
          ysb_grade_level_id: "",
          ysb_kelas_id: "",
        };
      }

      if (name === "ysb_school_id") {
        return {
          ...prev,
          ysb_school_id: value,
          ysb_grade_level_id: "",
          ysb_kelas_id: "",
        };
      }

      if (
        name === "ysb_grade_level_id"
      ) {
        return {
          ...prev,
          ysb_grade_level_id: value,
          ysb_kelas_id: "",
        };
      }

      return {
        ...prev,
        [name]: value,
      };
    });

    if (!isFirstLoad) {
      setIsFilterDirty(true);
    }
  };

  /*
  |--------------------------------------------------------------------------
  | BUTTON CARI
  |--------------------------------------------------------------------------
  */

  const handleCari = async () => {
    if (
      loadingSchool ||
      loadingLevel ||
      loadingKelas
    ) {
      Swal.fire({
        icon: "info",
        title: "Mohon tunggu",
        text: "Data sekolah, tingkatan, atau kelas masih dimuat.",
      });

      return;
    }

    const gradeValid =
      getDataLevel.length === 0 ||
      !!form2.ysb_grade_level_id;

    const kelasValid =
      getDataKelas.length === 0 ||
      !!form2.ysb_kelas_id;

    if (
      !form2.ysb_semester_id ||
      !form2.ysb_branch_id ||
      !form2.ysb_school_id ||
      !gradeValid ||
      !kelasValid
    ) {
      Swal.fire({
        icon: "warning",
        title: "Filter belum lengkap",
        text: "Pastikan Semester, Cabang, Sekolah, Tingkatan, dan Kelas sudah dipilih.",
      });

      return;
    }

    setGetData([]);
    setSearchKeyword("");
    setTablePage(1);

    await GetResponseData();

    setIsFilterDirty(false);
  };

  /*
  |--------------------------------------------------------------------------
  | DELETE
  |--------------------------------------------------------------------------
  */

  const deleteById = (deleteId) => {
    Swal.fire({
      title: "Apakah Kamu Yakin?",
      text: "Data yang dihapus tidak bisa dikembalikan",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, Hapus",
      cancelButtonText: "Batal",
      showLoaderOnConfirm: true,
      allowOutsideClick: () =>
        !Swal.isLoading(),

      preConfirm: async () => {
        try {
          const response =
            await APISD.delete(
              `/api/fases/${deleteId}`,
              fetchParams
            );

          if (response?.data?.error) {
            throw new Error(
              response?.data?.message
            );
          }

          return response;
        } catch (error) {
          Swal.showValidationMessage(
            error?.response?.data?.message ||
              "Gagal menghapus data"
          );

          return false;
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        ToastSuccess.fire({
          icon: "success",
          title: "Data berhasil dihapus",
        });

        GetResponseData();
      }
    });
  };

  /*
  |--------------------------------------------------------------------------
  | SEARCH FRONTEND
  |--------------------------------------------------------------------------
  */

  const nameCollator = useMemo(
    () =>
      new Intl.Collator("id", {
        sensitivity: "base",
        numeric: true,
      }),
    []
  );

  const filteredData = useMemo(() => {
    const query = (
      searchKeyword || ""
    )
      .trim()
      .toLowerCase();

    const base = !query
      ? getData || []
      : (getData || []).filter((item) => {
          const nameFase = (
            item?.name_fase || ""
          )
            .toString()
            .toLowerCase();

          const description = (
            item?.description || ""
          )
            .toString()
            .toLowerCase();

          return (
            nameFase.includes(query) ||
            description.includes(query)
          );
        });

    return [...base].sort((a, b) =>
      nameCollator.compare(
        (a?.name_fase || "")
          .toString()
          .trim(),
        (b?.name_fase || "")
          .toString()
          .trim()
      )
    );
  }, [
    getData,
    searchKeyword,
    nameCollator,
  ]);

  /*
  |--------------------------------------------------------------------------
  | PAGINATION
  |--------------------------------------------------------------------------
  */

  const totalRows = filteredData.length;

  const totalPages = useMemo(() => {
    const pages = Math.ceil(
      totalRows / Math.max(1, rowsPerPage)
    );

    return pages <= 0 ? 1 : pages;
  }, [
    totalRows,
    rowsPerPage,
  ]);

  useEffect(() => {
    setTablePage(1);
  }, [
    searchKeyword,
    getData,
  ]);

  useEffect(() => {
    if (tablePage > totalPages) {
      setTablePage(totalPages);
    }

    if (tablePage < 1) {
      setTablePage(1);
    }
  }, [
    tablePage,
    totalPages,
  ]);

  const paginatedData = useMemo(() => {
    const safeRows = Math.max(
      1,
      rowsPerPage
    );

    const start =
      (tablePage - 1) * safeRows;

    return filteredData.slice(
      start,
      start + safeRows
    );
  }, [
    filteredData,
    tablePage,
    rowsPerPage,
  ]);

  const pageNumbers = useMemo(() => {
    const maxButtons = 5;
    const pages = [];

    if (totalPages <= maxButtons) {
      for (
        let number = 1;
        number <= totalPages;
        number += 1
      ) {
        pages.push(number);
      }

      return pages;
    }

    const left = Math.max(
      1,
      tablePage - 1
    );

    const right = Math.min(
      totalPages,
      tablePage + 1
    );

    pages.push(1);

    if (left > 2) {
      pages.push("...");
    }

    for (
      let number = left;
      number <= right;
      number += 1
    ) {
      if (
        number !== 1 &&
        number !== totalPages
      ) {
        pages.push(number);
      }
    }

    if (right < totalPages - 1) {
      pages.push("...");
    }

    pages.push(totalPages);

    return pages.filter(
      (value, index, array) =>
        array.indexOf(value) === index
    );
  }, [
    tablePage,
    totalPages,
  ]);

  const goToPage = (nextPage) => {
    const selectedPage = Math.min(
      Math.max(
        1,
        Number(nextPage) || 1
      ),
      totalPages
    );

    setTablePage(selectedPage);
  };

  /*
  |--------------------------------------------------------------------------
  | UPDATE MODAL
  |--------------------------------------------------------------------------
  */

  const viewModalUpdate = (
    updateId,
    fase
  ) => {
    setModalUpdate(true);
    setId(updateId);
    setDataUpdate(fase);
  };

  /*
  |--------------------------------------------------------------------------
  | COMPONENT SELECT FILTER
  |--------------------------------------------------------------------------
  */

  const filterSelectStyle = {
    border: "1px solid #d9defa",
    borderRadius: "12px",
    fontSize: "14px",
    padding: "10px 12px",
    background: "#fff",
  };

  /*
  |--------------------------------------------------------------------------
  | UI
  |--------------------------------------------------------------------------
  */

  return (
    <div className="body">
      <style>{filterCss}</style>

      {modalAdd && (
        <ModalAdd
          GetResponseData={
            GetResponseData
          }
          show={modalAdd}
          onHide={() =>
            setModalAdd(false)
          }
        />
      )}

      {modalUpdate && (
        <ModalUpdate
          GetResponseData={
            GetResponseData
          }
          id={id}
          dataUpdate={dataUpdate}
          show={modalUpdate}
          onHide={() =>
            setModalUpdate(false)
          }
        />
      )}

      {/* HEADER */}
      <div className="page-header-card">
        {isTabletOrMobile ? (
          <>
            <div className="page-header-top d-flex">
              <div className="page-title-wrap">
                <span className="page-title-icon">
                  <FontAwesomeIcon
                    icon={faList}
                  />
                </span>

                <h4 className="page-title-text">
                  Kegiatan Kokurikuler
                </h4>
              </div>
            </div>

            <div className="ml-auto">
              <button
                onClick={() =>
                  setModalAdd(true)
                }
                className="btn btn-create"
                style={{
                  borderRadius: 12,
                  padding: "8px 14px",
                  boxShadow:
                    "0 10px 24px rgba(108,99,255,0.18)",
                }}
              >
                <FontAwesomeIcon
                  icon={faPlus}
                />{" "}
                Kegiatan
              </button>
            </div>

            <nav
              aria-label="breadcrumb"
              className="custom-breadcrumb-nav mt-4"
            >
              <ol className="custom-breadcrumb">
                <li className="custom-breadcrumb-item">
                  <Link to="/matpels">
                    Mata Pelajaran
                  </Link>
                </li>

                <li className="custom-breadcrumb-separator">
                  /
                </li>

                <li
                  className="custom-breadcrumb-item active"
                  aria-current="page"
                >
                  Kegiatan Kokurikuler
                </li>
              </ol>
            </nav>
          </>
        ) : (
          <>
            <div className="page-header-top d-flex">
              <div className="page-title-wrap">
                <span className="page-title-icon">
                  <FontAwesomeIcon
                    icon={faList}
                  />
                </span>

                <h4 className="page-title-text">
                  Kegiatan Kokurikuler
                </h4>
              </div>

              <div className="ml-auto">
                <button
                  onClick={() =>
                    setModalAdd(true)
                  }
                  className="btn btn-create"
                  style={{
                    borderRadius: 12,
                    padding: "8px 14px",
                    boxShadow:
                      "0 10px 24px rgba(108,99,255,0.18)",
                  }}
                >
                  <FontAwesomeIcon
                    icon={faPlus}
                  />{" "}
                  Tambah Kegiatan
                </button>
              </div>
            </div>

            <nav
              aria-label="breadcrumb"
              className="custom-breadcrumb-nav mt-4"
            >
              <ol className="custom-breadcrumb">
                <li className="custom-breadcrumb-item">
                  <Link to="/matpels">
                    Mata Pelajaran
                  </Link>
                </li>

                <li className="custom-breadcrumb-separator">
                  /
                </li>

                <li
                  className="custom-breadcrumb-item active"
                  aria-current="page"
                >
                  Kegiatan Kokurikuler
                </li>
              </ol>
            </nav>
          </>
        )}
      </div>

      <div className="body-content">
        {/* FILTER MOBILE */}
        {isTabletOrMobile ? (
          <div className="title-page">
            <Row
              style={{
                marginTop: "10px",
                padding: "0 12px",
              }}
            >
              <select
                className="mr-2 kk-mobile-filter"
                name="ysb_semester_id"
                value={
                  form2.ysb_semester_id
                }
                onChange={handleChange}
                style={filterSelectStyle}
              >
                <option
                  value=""
                  hidden
                >
                  {namaTA} (Semester{" "}
                  {namaSmstr})
                </option>

                {getDataSemesterMap.map(
                  (semester) => (
                    <option
                      key={
                        semester?.id
                      }
                      value={
                        semester?.id
                      }
                    >
                      {
                        semester?.name_year
                      }{" "}
                      (Semester{" "}
                      {
                        semester?.semester
                      }
                      )
                    </option>
                  )
                )}
              </select>
            </Row>

            <Row
              style={{
                marginTop: "10px",
                padding: "0 12px",
              }}
            >
              <select
                className="mr-2 kk-mobile-filter"
                name="ysb_branch_id"
                value={
                  form2.ysb_branch_id
                }
                onChange={handleChange}
                style={filterSelectStyle}
              >
                <option
                  value=""
                  hidden
                >
                  Pilih Cabang
                </option>

                {getDataBranch.map(
                  (branch) => (
                    <option
                      key={
                        branch?.branch_code
                      }
                      value={
                        branch?.branch_code
                      }
                    >
                      {
                        branch?.branch_name
                      }
                    </option>
                  )
                )}
              </select>
            </Row>

            <Row
              style={{
                marginTop: "10px",
                padding: "0 12px",
              }}
            >
              <select
                className="mr-2 kk-mobile-filter"
                name="ysb_school_id"
                value={
                  form2.ysb_school_id
                }
                onChange={handleChange}
                disabled={loadingSchool}
                style={{
                  ...filterSelectStyle,
                  backgroundColor:
                    loadingSchool
                      ? "#f5f5f5"
                      : "#fff",
                  cursor: loadingSchool
                    ? "not-allowed"
                    : "pointer",
                }}
              >
                <option
                  value=""
                  hidden
                >
                  {loadingSchool
                    ? "Memuat data sekolah..."
                    : "Pilih Sekolah"}
                </option>

                {!loadingSchool &&
                  getDataSchool.map(
                    (school) => (
                      <option
                        key={
                          school?.school_code
                        }
                        value={
                          school?.school_code
                        }
                      >
                        {
                          school?.school_name
                        }
                      </option>
                    )
                  )}
              </select>
            </Row>

            <Row
              style={{
                marginTop: "10px",
                padding: "0 12px",
              }}
            >
              <select
                className="mr-2 kk-mobile-filter"
                name="ysb_grade_level_id"
                value={
                  form2.ysb_grade_level_id
                }
                onChange={handleChange}
                disabled={loadingLevel}
                style={{
                  ...filterSelectStyle,
                  backgroundColor:
                    loadingLevel
                      ? "#f5f5f5"
                      : "#fff",
                  cursor: loadingLevel
                    ? "not-allowed"
                    : "pointer",
                }}
              >
                <option
                  value=""
                  hidden
                >
                  {loadingLevel
                    ? "Memuat data tingkatan..."
                    : "Pilih Tingkatan"}
                </option>

                {!loadingLevel &&
                  getDataLevel.map(
                    (level) => (
                      <option
                        key={level?.id}
                        value={level?.id}
                      >
                        {
                          level?.name_level
                        }
                      </option>
                    )
                  )}
              </select>
            </Row>

            <Row
              style={{
                marginTop: "10px",
                padding: "0 12px",
              }}
            >
              <select
                className="mr-2 kk-mobile-filter"
                name="ysb_kelas_id"
                value={
                  form2.ysb_kelas_id
                }
                onChange={handleChange}
                disabled={loadingKelas}
                style={{
                  ...filterSelectStyle,
                  backgroundColor:
                    loadingKelas
                      ? "#f5f5f5"
                      : "#fff",
                  cursor: loadingKelas
                    ? "not-allowed"
                    : "pointer",
                }}
              >
                <option
                  value=""
                  hidden
                >
                  {loadingKelas
                    ? "Memuat data kelas..."
                    : "Pilih Kelas"}
                </option>

                {!loadingKelas &&
                  getDataKelas.map(
                    (kelas) => (
                      <option
                        key={kelas?.id}
                        value={kelas?.id}
                      >
                        {
                          kelas?.name_kelas
                        }
                      </option>
                    )
                  )}
              </select>
            </Row>

            <Row
              style={{
                marginTop: "12px",
                padding: "0 12px",
              }}
            >
              <button
                type="button"
                onClick={handleCari}
                disabled={
                  !isFilterComplete
                }
                className="btn kk-filter-button"
                style={{
                  backgroundColor:
                    !isFilterComplete
                      ? "#c9c9c9"
                      : "#eca91a",
                  cursor:
                    !isFilterComplete
                      ? "not-allowed"
                      : "pointer",
                }}
              >
                Cari
              </button>
            </Row>
          </div>
        ) : (
          /* FILTER DESKTOP */
          <div className="mb-3">
            {loading ? (
              <>
                <div className="mb-3 d-flex">
                  <div
                    className="shimmer shimmer-select mr-2"
                    style={{
                      width: 180,
                    }}
                  />

                  <div
                    className="shimmer shimmer-select mr-2"
                    style={{
                      width: 220,
                    }}
                  />

                  <div
                    className="shimmer shimmer-select mr-2"
                    style={{
                      width: 220,
                    }}
                  />
                </div>

                <div className="d-flex">
                  <div
                    className="shimmer shimmer-select mr-2"
                    style={{
                      width: 140,
                    }}
                  />

                  <div
                    className="shimmer shimmer-select mr-2"
                    style={{
                      width: 140,
                    }}
                  />

                  <div
                    className="shimmer shimmer-select mr-2"
                    style={{
                      width: 60,
                    }}
                  />
                </div>
              </>
            ) : (
              <div className="mb-3 mt-1">
                <div className="d-flex">
                  <select
                    className="mr-2 kk-filter-select"
                    name="ysb_semester_id"
                    value={
                      form2.ysb_semester_id
                    }
                    onChange={
                      handleChange
                    }
                  >
                    <option
                      value=""
                      hidden
                    >
                      {namaTA} (Semester{" "}
                      {namaSmstr})
                    </option>

                    {getDataSemesterMap.map(
                      (semester) => (
                        <option
                          key={
                            semester?.id
                          }
                          value={
                            semester?.id
                          }
                        >
                          {
                            semester?.name_year
                          }{" "}
                          (Semester{" "}
                          {
                            semester?.semester
                          }
                          )
                        </option>
                      )
                    )}
                  </select>

                  <select
                    className="mr-2 kk-filter-select"
                    name="ysb_branch_id"
                    value={
                      form2.ysb_branch_id
                    }
                    onChange={
                      handleChange
                    }
                  >
                    <option
                      value=""
                      hidden
                    >
                      Pilih Cabang
                    </option>

                    {getDataBranch.map(
                      (branch) => (
                        <option
                          key={
                            branch?.branch_code
                          }
                          value={
                            branch?.branch_code
                          }
                        >
                          {
                            branch?.branch_name
                          }
                        </option>
                      )
                    )}
                  </select>

                  <select
                    className="mr-2 kk-filter-select"
                    name="ysb_school_id"
                    value={
                      form2.ysb_school_id
                    }
                    onChange={
                      handleChange
                    }
                    disabled={
                      loadingSchool
                    }
                  >
                    <option
                      value=""
                      hidden
                    >
                      {loadingSchool
                        ? "Memuat data sekolah..."
                        : "Pilih Sekolah"}
                    </option>

                    {!loadingSchool &&
                      getDataSchool.map(
                        (school) => (
                          <option
                            key={
                              school?.school_code
                            }
                            value={
                              school?.school_code
                            }
                          >
                            {
                              school?.school_name
                            }
                          </option>
                        )
                      )}
                  </select>
                </div>

                <div className="mt-3 d-flex">
                  <select
                    className="mr-2 kk-filter-select"
                    name="ysb_grade_level_id"
                    value={
                      form2.ysb_grade_level_id
                    }
                    onChange={
                      handleChange
                    }
                    disabled={
                      loadingLevel
                    }
                  >
                    <option
                      value=""
                      hidden
                    >
                      {loadingLevel
                        ? "Memuat data tingkatan..."
                        : "Pilih Tingkatan"}
                    </option>

                    {!loadingLevel &&
                      getDataLevel.map(
                        (level) => (
                          <option
                            key={
                              level?.id
                            }
                            value={
                              level?.id
                            }
                          >
                            {
                              level?.name_level
                            }
                          </option>
                        )
                      )}
                  </select>

                  <select
                    className="mr-2 kk-filter-select"
                    name="ysb_kelas_id"
                    value={
                      form2.ysb_kelas_id
                    }
                    onChange={
                      handleChange
                    }
                    disabled={
                      loadingKelas
                    }
                  >
                    <option
                      value=""
                      hidden
                    >
                      {loadingKelas
                        ? "Memuat data kelas..."
                        : "Pilih Kelas"}
                    </option>

                    {!loadingKelas &&
                      getDataKelas.map(
                        (kelas) => (
                          <option
                            key={
                              kelas?.id
                            }
                            value={
                              kelas?.id
                            }
                          >
                            {
                              kelas?.name_kelas
                            }
                          </option>
                        )
                      )}
                  </select>

                  <button
                    type="button"
                    onClick={handleCari}
                    disabled={
                      !isFilterComplete
                    }
                    className="btn kk-filter-button"
                    style={{
                      backgroundColor:
                        !isFilterComplete
                          ? "#c9c9c9"
                          : "#eca91a",
                      cursor:
                        !isFilterComplete
                          ? "not-allowed"
                          : "pointer",
                    }}
                  >
                    Cari
                  </button>
                </div>
              </div>
            )}
          </div>
        )}

        {/* LOADING DATA TABLE */}
        {isFetching && (
          <div
            className="text-center"
            style={{
              padding: "10px 0",
            }}
          >
            <PulseLoader
              color="#3f5bea"
              size={12}
            />
          </div>
        )}

        {/* DATA TABLE */}
        {!isFetching && (
          <>
            <div className="mt-1">
              <div className="at-search">
                <input
                  className="at-input"
                  placeholder="Cari Fase atau Deskripsi"
                  value={searchKeyword}
                  onChange={(event) =>
                    setSearchKeyword(
                      event.target.value
                    )
                  }
                />
              </div>
            </div>

            <Col
              xl="12"
              sm="12"
            >
              <div className="mt-3 body-table">
                <table
                  className="table dt-responsive nowrap w-100"
                  id="basic-datatable"
                >
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Fase</th>
                      <th>Deskripsi</th>
                      <th>Tingkatan</th>
                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {paginatedData.length >
                    0 ? (
                      paginatedData.map(
                        (row, index) => (
                          <tr
                            key={
                              row?.id ||
                              index
                            }
                          >
                            <td
                              style={{
                                lineHeight:
                                  "2",
                              }}
                            >
                              {(tablePage -
                                1) *
                                rowsPerPage +
                                (index + 1)}
                            </td>

                            <td
                              style={{
                                lineHeight:
                                  "2",
                              }}
                            >
                              {row?.name_fase ||
                                "-"}
                            </td>

                            <td
                              style={{
                                lineHeight:
                                  "2",
                              }}
                            >
                              {row?.description ||
                                "-"}
                            </td>

                            <td
                              style={{
                                lineHeight:
                                  "2",
                              }}
                            >
                              <div
                                style={{
                                  backgroundColor:
                                    "#4747AC",
                                  borderRadius:
                                    "3px",
                                  cursor:
                                    "pointer",
                                  width: "70px",
                                  color:
                                    "white",
                                  paddingLeft:
                                    "8px",
                                }}
                              >
                                <FaArrowAltCircleRight />{" "}
                                Detail
                              </div>
                            </td>

                            <td
                              style={{
                                lineHeight:
                                  "2",
                              }}
                            >
                              <div
                                style={{
                                  display:
                                    "flex",
                                  alignItems:
                                    "center",
                                  gap: "6px",
                                  flexWrap:
                                    "nowrap",
                                  whiteSpace:
                                    "nowrap",
                                }}
                              >
                                <button
                                  type="button"
                                  className="button-edit button-table"
                                  onClick={() =>
                                    viewModalUpdate(
                                      row?.id,
                                      row
                                    )
                                  }
                                >
                                  <FontAwesomeIcon
                                    icon={
                                      faPenToSquare
                                    }
                                  />
                                </button>

                                <button
                                  type="button"
                                  className="button-delete button-table"
                                  onClick={() =>
                                    deleteById(
                                      row?.id
                                    )
                                  }
                                >
                                  <FontAwesomeIcon
                                    icon={
                                      faTrash
                                    }
                                  />
                                </button>
                              </div>
                            </td>
                          </tr>
                        )
                      )
                    ) : (
                      <tr>
                        <td
                          colSpan="5"
                          className="text-center"
                          style={{
                            padding:
                              "20px",
                          }}
                        >
                          Data tidak ditemukan
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

                {filteredData.length >
                  0 && (
                  <div className="at-pagination">
                    <div
                      className="d-flex"
                      style={{
                        gap: 8,
                        alignItems:
                          "center",
                      }}
                    >
                      <span className="at-page-info">
                        Menampilkan{" "}
                        <b>
                          {Math.min(
                            (tablePage -
                              1) *
                              rowsPerPage +
                              1,
                            totalRows
                          )}
                        </b>
                        -
                        <b>
                          {Math.min(
                            tablePage *
                              rowsPerPage,
                            totalRows
                          )}
                        </b>{" "}
                        dari{" "}
                        <b>
                          {totalRows}
                        </b>{" "}
                        data
                      </span>

                      <select
                        className="at-page-size"
                        value={
                          rowsPerPage
                        }
                        onChange={(
                          event
                        ) => {
                          const value =
                            Number(
                              event
                                .target
                                .value
                            ) || 10;

                          setRowsPerPage(
                            value
                          );

                          setTablePage(
                            1
                          );
                        }}
                      >
                        <option
                          value={10}
                        >
                          10 / halaman
                        </option>

                        <option
                          value={25}
                        >
                          25 / halaman
                        </option>

                        <option
                          value={50}
                        >
                          50 / halaman
                        </option>

                        <option
                          value={100}
                        >
                          100 / halaman
                        </option>
                      </select>
                    </div>

                    <div
                      className="d-flex"
                      style={{
                        gap: 8,
                        alignItems:
                          "center",
                      }}
                    >
                      <button
                        type="button"
                        className="at-page-btn"
                        onClick={() =>
                          goToPage(
                            tablePage -
                              1
                          )
                        }
                        disabled={
                          tablePage <= 1
                        }
                      >
                        Prev
                      </button>

                      <div className="at-page-numbers">
                        {pageNumbers.map(
                          (
                            pageNumber,
                            index
                          ) =>
                            pageNumber ===
                            "..." ? (
                              <span
                                key={`dots-${index}`}
                                className="at-page-info"
                                style={{
                                  padding:
                                    "0 6px",
                                }}
                              >
                                ...
                              </span>
                            ) : (
                              <button
                                type="button"
                                key={`page-${pageNumber}`}
                                className={`at-page-number ${
                                  pageNumber ===
                                  tablePage
                                    ? "active"
                                    : ""
                                }`}
                                onClick={() =>
                                  goToPage(
                                    pageNumber
                                  )
                                }
                              >
                                {
                                  pageNumber
                                }
                              </button>
                            )
                        )}
                      </div>

                      <button
                        type="button"
                        className="at-page-btn"
                        onClick={() =>
                          goToPage(
                            tablePage +
                              1
                          )
                        }
                        disabled={
                          tablePage >=
                          totalPages
                        }
                      >
                        Next
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </Col>
          </>
        )}
      </div>
    </div>
  );
}